module.exports = __webpack_public_path__ + "img/Orbiting-3.c63f2f0b.png";